var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLastView = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.2732 15.9999C21.2732 18.6399 19.1399 20.7732 16.4999 20.7732C13.8599 20.7732 11.7266 18.6399 11.7266 15.9999C11.7266 13.3599 13.8599 11.2266 16.4999 11.2266C19.1399 11.2266 21.2732 13.3599 21.2732 15.9999Z",
    stroke: "#263349",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.4998 27.0266C21.2065 27.0266 25.5931 24.2533 28.6465 19.4533C29.8465 17.5733 29.8465 14.4133 28.6465 12.5333C25.5931 7.73329 21.2065 4.95996 16.4998 4.95996C11.7931 4.95996 7.40646 7.73329 4.35312 12.5333C3.15312 14.4133 3.15312 17.5733 4.35312 19.4533C7.40646 24.2533 11.7931 27.0266 16.4998 27.0266Z",
    stroke: "#263349",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLastView, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/last-view.673f542a.svg";
export { ForwardRef as ReactComponent };